import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';

import { FormControl, FormItem, FormLabel, FormMessage, FormField as ShadcnFormField } from '@/components/ui/form';
import { Input } from '@/components/ui/input';

interface FormInputProps<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>;
    name: FieldPath<TFieldValues>;
    label: string;
    placeholder?: string;
    type?: string;
    disabled?: boolean;
    inputRef?: React.RefObject<HTMLInputElement>;
    children?: (field: any) => React.ReactNode;
}

export function FormInput<TFieldValues extends FieldValues>({
    control,
    name,
    label,
    placeholder,
    type = 'text',
    disabled = false,
    inputRef,
    children,
}: FormInputProps<TFieldValues>) {
    return (
        <ShadcnFormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel>{label}</FormLabel>
                    <FormControl>
                        {children ? (
                            children(field)
                        ) : (
                            <Input
                                type={type}
                                placeholder={placeholder}
                                disabled={disabled}
                                {...field}
                                ref={(el) => {
                                    field.ref(el);
                                    if (inputRef) {
                                        (inputRef as any).current = el;
                                    }
                                }}
                            />
                        )}
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
